import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { UserGroup} from '../../../_models/user_group';
import { UserZone} from '../../../_models/user_zone';
import { Zone} from '../../../_models/zone';

import { FormValidator } from '../../../_helpers/form.validator';
import { UserGroupValidator } from '../../userGroup.validator';

import { DbTransform } from '../../../_helpers/db.transform';

@Component({
  selector: 'app-userGroup-edit',
  templateUrl: './userGroup-edit.component.html'
})
export class UserGroupEditComponent implements OnInit {

  dbt: DbTransform;

  title: string;
  subtitle: string;

  userGroupForm: FormGroup;
  userZoneForm: FormGroup;

  userZoneModal: boolean;
  buttonSetUserZoneDisabled: boolean;
  deleteModal: boolean;

  actionModal: boolean;
  alertModal: boolean;
  infoModal: boolean;

  actionInfo: string;
  alertInfo: string;
  infoInfo: string;

  currentUserZone: UserZone;
  zoneUserListAux: UserZone[];

  lagerListAux: string[];
  zoneListAux: Zone[];

  // Variable para el control de las validaciones del formulario y sus mensajes.
  formValidator: FormValidator;


  @Input() currentUserGroup: UserGroup;
  @Input() zoneUserList: UserZone[];
  @Input() zoneList: Zone[];
  @Output() updateUserGroup = new EventEmitter<UserGroup>();
  @Output() deleteUserZone = new EventEmitter<UserZone>();
  @Output() addUserZone = new EventEmitter<UserZone>();
  @Output() showInfoModal = new EventEmitter<{ value: boolean, info: string, link: string, skin: string }>();

  constructor(
    public router: Router,
    private formBuilder: FormBuilder,
  ) {
    this.formValidator = new FormValidator();
  }

  // convenience getter for easy access to form fields
  get f() { return this.userGroupForm.controls; }

  ngOnInit() {

    this.dbt = new DbTransform(localStorage.getItem('enviroment')); //this.globals.currentUserEnviroment);

    console.log(' Grupo actual = ');
    console.log(this.currentUserGroup);

    console.log(' zoneUserList = ');
    console.log(this.zoneUserList);
    console.log(' zoneList = ');
    console.log(this.zoneList);

    this.zoneUserListAux = [];

    if (this.currentUserGroup[this.dbt.t('id')] !== null && this.currentUserGroup[this.dbt.t('id')] !== undefined) {
      this.zoneUserListAux = this.zoneUserList.filter( item =>
        item[this.dbt.t('group_id')].toString() === this.currentUserGroup[this.dbt.t('id')].toString() );
    }

    console.log(' zoneUserListAux = ');
    console.log(this.zoneUserListAux);

    // En esta variable se va a almacenar un listado con los almacenes existentes que tienen zonas asignadas.
    this.lagerListAux = [];

    // A partir de todas las zonas existentes se guarda un listado con sólo el nombre de los almacenes sin repetirlos.
    this.zoneList.forEach( item => {
      // console.log(' Zona a tratar:' + this.lagerListAux.indexOf(item[this.dbt.t('lager_zone')]));
      // console.log(item[this.dbt.t('lager_zone')]);
      if (this.lagerListAux.indexOf(item[this.dbt.t('lager_zone')]) === -1) {
        // console.log(' Encontrado nuevo almacén = ' + item[this.dbt.t('lager_zone')]);
        this.lagerListAux.push(item[this.dbt.t('lager_zone')]);
      }
    });

    console.log(' lagerListAux = ');
    console.log(this.lagerListAux);

    this.zoneListAux = [];


    // Inicialmente todos los modales no estarán visibles.
    this.userZoneModal = false;
    this.buttonSetUserZoneDisabled = true;
    this.deleteModal = false;

    this.userGroupForm = this.formBuilder.group({
      name: [this.currentUserGroup[this.dbt.t('name')], [Validators.required]],
      id: this.currentUserGroup[this.dbt.t('id')],
      description: [this.currentUserGroup[this.dbt.t('description')], [Validators.maxLength(120)]],
      activated: this.currentUserGroup[this.dbt.t('activated')]
    });

    this.userZoneForm = this.formBuilder.group({
      id: null,
      lager: null,
      zone: null,
      user_id: null,
      group_id: this.currentUserGroup[this.dbt.t('id')]
    });

    if ( this.currentUserGroup[this.dbt.t('activated')] === '1') {
      this.userGroupForm.controls.activated.setValue(1);
    } else {
      this.userGroupForm.controls.activated.setValue(0);
    }

    // Asignamos los mensajes de error asociados a las validaciones que vamos a usar en el formulario.
    this.formValidator.setTemplateMessages(UserGroupValidator.templateMessages);

    this.title = 'Módulo  Grupos de Usuarios';
    this.subtitle = 'Edición Grupos de Usuarios';

    this.actionInfo = '¿Desea guardar el Grupo de usuarios?';

    this.infoInfo = 'La acción se ha realizado correctamente.';

    // Se crean las subscripciones para el control de los campos del formulario.
    this.formValidator.subscribeFormGroup(this.userGroupForm);

  } // End function OnInit

  saveUserGroup(): void {
    console.log('this.currentUserGroup:');
    console.log(this.currentUserGroup);

    console.log('this.f.activated.value:');
    console.log(this.f.activated.value);

    if ( this.f.activated.value === null ) {
         this.f.activated.setValue(0);
    }

    this.currentUserGroup[this.dbt.t('id')] = this.f.id.value;
    this.currentUserGroup[this.dbt.t('name')] = this.f.name.value;
    this.currentUserGroup[this.dbt.t('description')] = this.f.description.value;
    this.currentUserGroup[this.dbt.t('activated')] = this.f.activated.value;

    const p = { ...this.currentUserGroup, ...this.userGroupForm.value };

    this.updateUserGroup.emit(p);

  } // End function saveUserGroup

  buttonNewUserZone() {
    console.log('-> -> Pulsado botón abrir modal nuevo UserZone:');

    this.showUserZoneModal(true);

  } // End function buttonNewUserZone

  buttonAddUserZone() {
    console.log('-> -> Pulsado botón confirmar nuevo UserZone:');

    let newUserZone = new UserZone();

    newUserZone[this.dbt.t('lager')] = this.userZoneForm.controls.zone.value[this.dbt.t('lager_zone')];
    newUserZone[this.dbt.t('zone_name')] = this.userZoneForm.controls.zone.value[this.dbt.t('zone_name')];
    newUserZone[this.dbt.t('zone_id')] = this.userZoneForm.controls.zone.value[this.dbt.t('id')];
    newUserZone[this.dbt.t('group_id')] = this.currentUserGroup[this.dbt.t('id')];
    newUserZone[this.dbt.t('location')] = '*';
    newUserZone[this.dbt.t('activate')] = 1;

    // Se lanza el proceso para insertar el nuevo permiso en la base de datos.
    this.addUserZone.emit(newUserZone);

    this.showUserZoneModal(false);

  } // End function buttonAddUserZone

  changeLager(): void {
    console.log('---> Cambiando Almacén:');
    console.log(this.userZoneForm.controls.lager.value);

    let listAux = [];

    // Se saca la lista de las zonas del almacén seleccionado.
    listAux = this.zoneList.filter( item =>
      item[this.dbt.t('lager_zone')].toString() === this.userZoneForm.controls.lager.value);

    // console.log('---> listAux:');
    // console.log(listAux);

    // A continuación se quitan las zonas para las cuales ese grupo ya tiene permiso concedido.
    this.zoneListAux = listAux.filter( z => {

      let ok = true;

      this.zoneUserListAux.forEach(zoneUser => {
        // console.log('---> ZoneUser a tratar:');
        // console.log(zoneUser);

        if ( z[this.dbt.t('zone_name')] === zoneUser[this.dbt.t('zone_name')] &&
             z[this.dbt.t('lager_zone')] === zoneUser[this.dbt.t('lager')]) {

              // console.log('---> Zona que ya tiene permisos.');

              ok = false;
        }
      });

      return ok;
    });

    // console.log('---> zoneListAux reducido:');
    // console.log(this.zoneListAux);

  } // End function changeLager

  changeZone(): void {
    console.log('---> Cambiando Zona:');
    console.log(this.userZoneForm.controls.zone.value);

    this.buttonSetUserZoneDisabled = false;

  } // End function changeZone

  // ------------------------------------
  //    VALIDACIÓN FINAL DEL FORMULARIO
  // ------------------------------------

  validateUserGroup(): void {

    // Se realizan las comprobaciones pertinentes para confirmar que los campos del formulario son correctos.

    if (this.userGroupForm.valid) {
      console.log('-------> Formulario userGroupForm correcto.');

      // Comprobaciones que no estén definidas ya en la declaración del formulario.
      if (this.userGroupForm.controls.name.value.trim() === '') {

        this.alertInfo = 'Debe de inscribir un nombre para el grupo.';
        this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});

      } else {
        this.showActionModal(true);
      }
    } else {
      console.log('-------> Formulario userGroupForm NO válido:');
      console.log(this.userGroupForm);

      this.alertInfo = 'El formulario no está correctamente rellenado:<br>';

      if (this.userGroupForm.controls.name.value === null) {
      this.alertInfo += ' - Debe introducir un nombre para el grupo.<br>';
      }
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
    }
  } // End function validateUserGroup

  buttonDeleteUserGroup(userZoneIn: UserZone) {
    console.log('-> -> Pulsado botón quitar permisos UserZone:');
    console.log(userZoneIn);

    this.currentUserZone = userZoneIn;

    this.showDeleteModal(true);

  } // End function buttonDeleteUserGroup

  showDeleteModal(value: boolean) {
    this.deleteModal = value;

  } // End function showDeleteModal

  showUserZoneModal(value: boolean) {
    this.userZoneModal = value;

  } // End function showUserZoneModal

  confirmDeleteUserZone() {
    console.log('-> -> Confirmación para Borrar UserZone:');

    this.deleteUserZone.emit(this.currentUserZone);

    this.showDeleteModal(false);

  } // End function confirmDeleteUserZone

  // ------- Función de regreso
  back(): void {
    // this._location.back();
    this.router.navigate(['/userGroup']);
  } // End function back

  // -----------------------------------------------
  //  FUNCIONES PARA EL CONTROL DE VENTANAS MODALES
  // -----------------------------------------------

  showActionModal(value: boolean) {
    this.actionModal = value;

  } // End function showActionModal

  confirmActionModal() {

    console.log('--> - -> Confirmada acción del modal.');

    this.saveUserGroup();

    this.showActionModal(false);
  } // End function confirmActionModal

} // End Class UserGroupEditComponent
